// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/generative_ai/agent/:id/logs/:invocation_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiAgentIdLogsDetail } from "./constants";
import type { GenerativeAiAgentIdLogsDetailResult } from "./types";
import { isGenerativeAiAgentIdLogsDetailResult } from "./validators";

export const getGenerativeAiAgentIdLogsDetail = reactQueryFetcherAdapter(
  generativeAiAgentIdLogsDetail,
  (
    signal: AbortSignal,
    id: string,
    invocationId: string,
    appGroupId?: string
  ): Promise<GenerativeAiAgentIdLogsDetailResult> => {
    return fetch(
      `/generative_ai/agent/${id}/logs/${invocationId}`,
      "GET",
      {
        app_group_id: appGroupId,
      },
      { signal }
    );
  },
  isGenerativeAiAgentIdLogsDetailResult
);
